import { type RefObject, useEffect, useRef } from "react";
import { type GroupedVirtuosoHandle } from "react-virtuoso";

// Delay to allow react-virtuoso to complete item measurement after data arrives.
const SCROLL_DELAY_MS = 300;

interface UseScrollToHighlightedItemParams {
  scrollRequestId: string | undefined;
  targetIndex: number;
  virtuosoRef: RefObject<GroupedVirtuosoHandle>;
  onScrollComplete?: () => void;
}

export function useScrollToHighlightedItem(params: UseScrollToHighlightedItemParams) {
  const { scrollRequestId, targetIndex, virtuosoRef, onScrollComplete } = params;
  const onScrollCompleteRef = useRef(onScrollComplete);
  onScrollCompleteRef.current = onScrollComplete;

  useEffect(() => {
    if (!scrollRequestId || targetIndex === -1) {
      return;
    }

    const scrollTimeoutId = setTimeout(() => {
      virtuosoRef.current?.scrollIntoView({
        index: targetIndex,
        align: "center",
        behavior: "smooth",
        done: () => {
          onScrollCompleteRef.current?.();
        },
      });
    }, SCROLL_DELAY_MS);

    return () => {
      clearTimeout(scrollTimeoutId);
    };
  }, [scrollRequestId, targetIndex, virtuosoRef]);
}
